<template>
  <div class="screen page quotes b-soft">
    <div class="grid">
      <section class="layout">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <form class="form no-select">
                <div class="row">
                  <div class="col-12" v-bind:class="{'filled': filter_global_cotizacion != ''}">
                    <input id="global" type="text" v-model="filter_global_cotizacion" placeholder="Buscar por nombre, cliente o creador..." @input="debounceSearch">
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="row h-items-center">
            <div v-if="cotizaciones_filtradas.length" class="col-12">
              <p class="t-14-px t-center">
                Se muestran {{cotizaciones_filtradas.length}} resultados
                <br>
                <br>
              </p>
            </div>
            <div class="col-12 box-container b-white moves-container no-select">
              <ul v-if="cotizaciones_filtradas.length" class="list-container container">
                <li v-for="cotizacion in cotizaciones_filtradas" v-bind:key="cotizacion.id" class="row v-items-center">
                  <div class="col" v-on:click.prevent="goTo('/cotizacion/'+cotizacion.id)">
                    <div class="container">
                      <div class="row v-items-center">
                        <div class="col-auto">
                          <span class="icon-list" v-bind:style="{'background-color': cotizacion.color}">
                            <b class="t-18-px">{{cotizacion.nombre | initialText}}</b>
                          </span>
                        </div>
                        <div class="col">
                          <p class="t-complementary t-14-px">
                            <span>{{cotizacion.nombre | createFolio(cotizacion.id_cliente)}}</span>
                            <br>
                            <span class="t-upper t-10-px t-base" v-if="cotizacion.fecha_creacion">Creado: {{cotizacion.fecha_creacion.seconds | beautyFormatDate}}</span> <span class="t-upper t-10-px t-base" v-if="cotizacion.usuario_creador"> Por {{cotizacion.usuario_creador}}</span><span class="t-upper t-10-px t-base separador-fechas" v-if="cotizacion.fecha_creacion && cotizacion.fecha_modificacion"> / </span><span class="t-upper t-10-px t-base" v-if="cotizacion.fecha_modificacion">Editado: {{cotizacion.fecha_modificacion.seconds | beautyFormatDate}}</span> <span class="t-upper t-10-px t-base" v-if="cotizacion.usuario_editor"> Por {{cotizacion.usuario_editor}}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-auto">
                    <a href="#" class="t-complementary" v-on:click.prevent="deleteElement('cotizaciones', cotizacion.id)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                 </li>
              </ul>
              <p v-else class="t-center">
                <i class="fas fa-sad-cry t-48-px"></i>
                <br>
                <br>
                No se encontraron cotizaciones
              </p>
            </div>
          </div>
        </div>
      </section>
      <GetFooter />
    </div>
  </div>
</template>

<script>
import GetFooter from '@/components/footer.vue'
import router from '@/router'
import { db } from '@/firebase'
export default {
  name: 'app',
  components: {
    GetFooter
  },
  data() {
    return {
      filter_global_cotizacion: '',
      datos_cargados_totalmente: false, // Control de eficiencia
      timeout: null,
      limite_cotizaciones: 20,
      cotizaciones: [],
      cotizaciones_filtradas: [],
    }
  },
  created() {

    this.comenzar()

  },
  methods: {
    comenzar() {
      let vm = this;
      db.collection('cotizaciones')
        .orderBy('fecha_modificacion', 'desc')
        .limit(vm.limite_cotizaciones)
        .get()
        .then(snapshot => {
          vm.cotizaciones = snapshot.docs.map(doc => this.formatearCotizacion(doc));
          vm.cotizaciones_filtradas = vm.cotizaciones;
        });
    },  
    //Formatear las cotizaciones iniciales 
    formatearCotizacion(doc) {
      const d = doc.data();
      return {
        id: doc.id,
        nombre: d.nombre || '',
        usuario_creador: d.usuario_creador || '',
        usuario_editor: d.usuario_editor || '',
        color: d.color,
        fecha_creacion: d.fecha_creacion,
        fecha_modificacion: d.fecha_modificacion,
        id_cliente: d.id_cliente, 
        search_index: '',
      };
    },
    //Funcion para comenzar busqueda siempre y cuando el usuario tenga cierto sin escribir
    debounceSearch() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.ejecutarBusquedaGlobal();
      }, 600);
    },
    //Funcion para realizar la busqueda en todas las cotizaciones
    async ejecutarBusquedaGlobal() {
      var vm = this;

      //Funcion que permite coincidencias mas libres en la busqueda
      const limpiar = (txt) => {
        return (txt || "")
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') //Quitar acentos
        .replace(/\s+/g, ' ') //Evita multiples espacios y deja uno solo
        .replace(/\s+:/g, ':').replace(/:\s+/g, ':') //Ignora espacios entre los 2 puntos para la busqueda presisa
        .replace(/\s+:/g, '+').replace(/:\s+/g, '+') //Ignora espacios entre simbolo de + para busqueda compuesta
        .trim(); //Quitar espacios al inicio y final
      };

      const busqueda = limpiar(vm.filter_global_cotizacion);

      // Si borra la búsqueda, regresamos a la vista inicial de la carga inicial
      if (busqueda === '') {
        //vm.cotizaciones_filtradas = vm.cotizaciones.slice(0, vm.limite_cotizaciones);
        //return;
      }

      //Realizar la carga de todos los datos
      if (!vm.datos_cargados_totalmente) {
        console.log('Iniciando carga global para búsqueda...');
        const snapshot = await db.collection('cotizaciones').orderBy('fecha_modificacion', 'desc').get();
        
        const consulta_completa_cotizaciones = [];
        snapshot.forEach(doc => {
          const d = doc.data();

          const cotizacion_nombre = d.nombre || '';
          const cotizacion_creador = d.usuario_creador || '';
          const cotizacion_editor = d.usuario_editor || '';
          const cliente_contacto = (d.id_cliente && d.id_cliente.contacto) ? d.id_cliente.contacto : '';
          const cliente_empresa = (d.id_cliente && d.id_cliente.empresa) ? d.id_cliente.empresa : '';
          const cliente_nombre = (d.id_cliente && d.id_cliente.nombre) ? d.id_cliente.nombre : '';

          consulta_completa_cotizaciones.push({
            id: doc.id,
            nombre: cotizacion_nombre,
            usuario_creador: cotizacion_creador,
            usuario_editor: cotizacion_editor,
            color: d.color,
            fecha_creacion: d.fecha_creacion,
            fecha_modificacion: d.fecha_modificacion,
            id_cliente: d.id_cliente,
            search_index: limpiar(`cotizacion: ${cotizacion_nombre} creador: ${cotizacion_creador} editor: ${cotizacion_editor} contacto: ${cliente_contacto} empresa: ${cliente_empresa} cliente: ${cliente_nombre}`)
          });
        });

        vm.cotizaciones = consulta_completa_cotizaciones; 
        vm.datos_cargados_totalmente = true;
      }

      //Filtrar las cotizaciones buscando coincidencias
      vm.cotizaciones_filtradas = vm.cotizaciones.filter(cot => {        
        const terminos = busqueda.split('+').map(t => t.trim()).filter(t => t !== ''); // Dividimos la búsqueda por el símbolo + 

        return terminos.every(termino => cot.search_index.includes(termino)); //Nos aseguramos que cada uno de los terminos este incluido de lo contrario queda fuera de coincidencia
      });
    },
    deleteElement(collection, id){
      var vm = this
      if(window.confirm('¿Estás Seguro? Esto eliminará el elemento permanentemente.')){
        //Elimiar versiones de la cotizacion
        db.collection(collection).doc(id).collection('versiones')
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            doc.ref.delete();
          })
        })
        //Eliminar cotizacion
        db.collection(collection).doc(id).delete().then(function() {
          console.log('Document successfully deleted!')
          //Buscar dentro del arreglo y eliminar el elemento eliminado de la base de datos
          for (var i = vm.cotizaciones.length - 1; i >= 0; --i) {
              if (vm.cotizaciones[i].id == id) {
                  vm.cotizaciones.splice(i,1);
              }
          }
          // Eliminamos de ambos arrays locales
          vm.cotizaciones = vm.cotizaciones.filter(c => c.id !== id);
          vm.cotizaciones_filtradas = vm.cotizaciones_filtradas.filter(c => c.id !== id);
        }).catch(function(error) {
          alert('Error de ejecución')
          console.error('Error removing document: ', error)
        })
      }
    },
    goTo(url) {
      router.push({ path: url });
    }
  }
}
</script>